import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'flightFormat',
  standalone: false
})
export class FlightPipe implements PipeTransform {
  transform(value: string): any {
    if (!value) {
      return '';
    }

    return value.replace(/\(...\)/, '');
  }
}
